import { render } from "./milestone-form-complete.vue?vue&type=template&id=013cafd7&ts=true"
import script from "./milestone-form-complete.vue?vue&type=script&lang=ts"
export * from "./milestone-form-complete.vue?vue&type=script&lang=ts"

import "./milestone-form-complete.vue?vue&type=style&index=0&id=013cafd7&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__